const initialize = () => {
    $('#skipmenu').on('focus', function() {
		$(this).css('height', 'auto');
	}).on('blur', function() {
		$(this).css('height', '');
	}).on('keydown', function(e) {
		if (e.keyCode !== 13) return;
		$('#contentArea').find('.hidden-aria-target').trigger('focus');
		e.stopPropagation();
	});
};

export default {
    initialize,
};

